import React, { useState, useEffect } from 'react';
import i18next from "../../i18n.js";
import { useNavigate, NavLink } from "react-router-dom";
import { listTypes, urls, docTypeSearchParams } from '../../constants.js';
import { Button } from 'react-bootstrap';
import { getWordWithCorrectEnding, loadListData } from '../helpers/HelperFunctions.js';
import moment from 'moment';

const NewVacationWidget = () => {
    const [leftDaysCount, setLeftDaysCount] = useState(null);
    const [vacationStartDateStr, setVacationStartDateStr] = useState(null);
    const [daysCount, setDaysCount] = useState(0);

    const navigate = useNavigate();
    const handleBtnClick = () => navigate(urls.newVacationPage);

    useEffect(() => {
        fetch('/api/account/GetVacationLimits', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then((response) => response.json())
            .then((result) => {
                if (result && result.limits) {
                    if (result.limits.unusedVacationDaysMain) {
                        setLeftDaysCount(parseInt(result.limits.unusedVacationDaysMain));
                    }
                }
            });
        const nowDate = new Date();
        const maxDate = new Date(nowDate.getFullYear() + 100, nowDate.getMonth(), nowDate.getDate());
        const filter = [
            {
                name: 'ClaimDateStart',
                values: [moment(nowDate).format("YYYY-MM-DD"), moment(maxDate).format("YYYY-MM-DD")]
            },
            {
                name: 'State',
                values: ['signed']
            },
            {
                name: 'Creator',
                values: ['ME']
            }
        ];

        loadListData(listTypes.Documents, filter, 0, 10000).then(data => {
            if (data && data.items && data.items.length > 0) {
                const vacation = data.items[0];
                const startDateField = vacation.fields.find(f => f.name === 'ClaimDateStart');
                const endDateField = vacation.fields.find(f => f.name === 'ClaimDateEnd');
                const startDate = moment(startDateField.value, 'DD.MM.YYYY');
                const endDate = moment(endDateField.value, 'DD.MM.YYYY');
                const daysDif = endDate.diff(startDate, 'days');
                setDaysCount(daysDif + 1);
                setVacationStartDateStr(startDateField.value);
            }
        });
    }, []);

    return (<div className="widget new-vacation">
        <div className="new-widget-header">
            <div className="new-widget-title">{i18next.t("widgets.vacationTitle")}</div>
            <NavLink className="more-link" to={`${urls.documentsPage}?type=${docTypeSearchParams.vacationClaim}`}>{i18next.t("widgets.allVacationLink")}</NavLink>
        </div>
        {leftDaysCount != null && <div className="new-widget-subtitle">{i18next.t('widgets.leftVacationDaysText')
            .replace('{0}', `${leftDaysCount.toFixed()} ${getWordWithCorrectEnding(leftDaysCount, 'день')}`)}
        </div>}
        {vacationStartDateStr && <div className="new-widget-content">{i18next.t('widgets.nearestVacationText')
            .replace('{0}', vacationStartDateStr)
            .replace('{1}', daysCount.toFixed())
            .replace('{2}', getWordWithCorrectEnding(daysCount, 'календарний день')) }
        </div>}
        <Button variant="secondary" onClick={handleBtnClick}>{i18next.t("widgets.newVatation")}</Button>
    </div>);
}

export default NewVacationWidget;